import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus } from '../../actions/httpStatus';
import { Error } from './Error';

const ERROR_HTTP_STATUS = 500;

class NotFoundContainer extends React.Component {
    constructor(props) {
        super(props);

        //this will for now only be used by Contento views
        if (this.props.shouldDispatchHttpStatus) {
            this.props.updateHttpStatus();
        }
    }

    render() {
        return <Error {...this.props} />;
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateHttpStatus: () => dispatch(updateHttpStatus(ERROR_HTTP_STATUS)),
    };
};

export default connect(null, mapDispatchToProps)(NotFoundContainer);
